import {
  DialogBodyConfirmation,
  DialogBodyConfirmationProps,
} from '../dialog/DialogBodyConfirmation';
import { WizardContainer, WizardContainerProps } from './WizardContainer';
import { WizardStore, WizardElementProps, withoutWizardProps } from './Wizard';
export type DialogBodyConfirmationWizardProps = Omit<
  DialogBodyConfirmationProps,
  'onConfirm' | 'onCancel'
> &
  WizardContainerProps & {
    onConfirm?: () => Promise<string[][] | void>;
    onCancel?: () => Promise<string[][] | void>;
  };

export const DialogBodyConfirmationWizard = withoutWizardProps(
  (
    props: DialogBodyConfirmationWizardProps &
      WizardElementProps<WizardStore, string>,
  ) => {
    return WizardContainer(props, ({ go, set, ...containerProps }) => {
      const {
        title,
        description,
        onCancel,
        go: propGo,
        set: propSet,
        onConfirm,
      } = props;
      return (
        <DialogBodyConfirmation
          title={title}
          description={description}
          onCancel={async () => {
            const keyValuePairs = await onCancel?.();
            if (keyValuePairs) {
              for (const [key, value] of keyValuePairs) {
                propSet(key, value);
              }
            }
            propGo(undefined);
          }}
          onConfirm={async () => {
            const keyValuePairs = await onConfirm?.();
            if (keyValuePairs) {
              for (const [key, value] of keyValuePairs) {
                propSet(key, value);
              }
            }
            propGo('OutcomeSubmit');
          }}
          {...containerProps}
        />
      );
    });
  },
);
